import * as React from 'react';
import { useApiMutation } from 'client/core/network/hooks/useApiMutation';
import { AuthApi } from '../AuthApi';
import { useAuth, AuthActions, useCurrentUser } from '../AuthModule';
import { Button } from 'antd';
import { useDispatch } from 'react-redux';
import { UserLogic } from 'common/schema/UserLogic';
import { LogoutOutlined } from '@ant-design/icons';
import { logger } from 'client/core/logger/logger';
import { resolveApiPath } from 'client/core/appConfig';

export interface ILogoutButtonProps {
  text?: string;
  hideIcon?: boolean;
}

/**
 * Gestisce il logout dell'utente corrente, sia dalla sessione remota che dai
 * dati locali.
 */
export function LogoutButton(props: ILogoutButtonProps) {
  const auth = useAuth();
  const user = useCurrentUser();
  const dispatch = useDispatch();
  const [logout] = useApiMutation(AuthApi.logout, {});

  if (!auth.logged) return null;
  if (!UserLogic.canLogout(user)) return null;

  const text = props.text ?? 'Logout';

  if (user?.originalStrategy === 'saml') {
    return (
      <a href={resolveApiPath('/auth/iam/slo')}>
        {!props.hideIcon && <LogoutOutlined />} {text}
      </a>
    );
  }

  if (user?.originalStrategy === 'openweb') {
    return (
      <a href={resolveApiPath('/auth/openweb/logout')}>
        {!props.hideIcon && <LogoutOutlined />} {text}
      </a>
    );
  }

  const handleLogout = async () => {
    switch (user?.originalStrategy) {
      // Tranne nel caso di IAM OpenAM, dobbiamo effettuare il reload della
      // pagina impostando `isLogged` a false.
      default:
        await logout({});
        dispatch(AuthActions.logout());
        break;
    }
  };

  return (
    <a onClick={handleLogout}>
      {!props.hideIcon && <LogoutOutlined />} {text}
    </a>
  );
}
